// extracted by mini-css-extract-plugin
export var billingAddress = "_xs-g";
export var contactInfo = "_xs-d";
export var customerInfoContainer = "_xs-c";
export var customerInfoContainerMobile = "_xs-h";
export var customerInfoRow = "_xs-a";
export var customerInfoSection = "_xs-b";
export var fullWidthDividerMobile = "_xs-i";
export var imageContainer = "_xs-1";
export var paymentMethod = "_xs-e";
export var priceText = "_xs-6";
export var priceTextMobile = "_xs-7";
export var product = "_xs-0";
export var productImage = "_xs-2";
export var productInfo = "_xs-4";
export var productMobile = "_xs-9";
export var productTitle = "_xs-8";
export var quantityBadge = "_xs-3";
export var quantityText = "_xs-5";
export var shippingAddress = "_xs-f";